const Icon = require('../../utils/icon.js');
const { toHTML, client } = require('../../../src/utils/sanity/index.js');

const { projectId, dataset } = client.config();
const { buildSrc } = require('@sanity-image/url-builder');

module.exports = function ({
  title,
  subtitle,
  text,
  terms,
  image,
  signup_preset: preset,
  subscriptionId,
  formId,
  allowAlreadySubscribed = false,
  blockHelpers,
  ...data
}) {
  if (preset) {
    subscriptionId = {
      enews: 9426584,
      cinemail: 87581886,
      edmail: 87582108,
      membermail: 87582144,
      storemail: 87582274,
      'kids-and-families': 87582085,
      'food-and-wine-events': 87582418,
      'asian-and-pacific-art': 103481713
    }[preset];

    if (subscriptionId) {
      preset = undefined;
    }
  }

  return Promise.resolve(image).then(
    (image) => `<aside class="emailSignup"${imageHtml(image)} ${blockHelpers.id(
      data
    )}>
    
    <header>
      <h1>${title}</h1>
      ${subtitle ? `<p>${subtitle}</p>` : ``}
      ${text ? toHTML(text, data) : ``}
    </header>

    <div x-data='emailSignup(${JSON.stringify({
      formId,
      subscriptionTypes: subscriptionId && [subscriptionId].flat()
    })})'>
      <div x-bind="placeholder" role="presentation" data-hsfc-id="Renderer" class="hsfc-FormWrapper emailSignup__form-placeholder">
        <div class="hsfc-Step__Content">
          <div class="hsfc-Row">
            <div class="hsfc-TextField">
              <label class="hsfc-FieldLabel">First name</label>
              <input type="text" class="hsfc-TextInput" disabled/>
            </div>

            <div class="hsfc-EmailField">
              <label class="hsfc-FieldLabel">Email</label>
              <input type="email" class="hsfc-EmailInput" disabled/>
            </div>
          </div>
          
          <div class="hsfc-NavigationRow">
            <div class="hsfc-NavigationRow__Buttons">
              <button class="hsfc-Button" disabled>Sign up</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    ${terms ? `<footer>${toHTML(terms, data)}</footer>` : ``}
  </aside>`
  );
};

function imageHtml(image) {
  if (!image) return ``;

  try {
    const { _id: id, hotspot, crop } = image;

    let { x = 0.5, y = 0.5 } = getAdjustedHotspot(hotspot, crop);

    return ` style="background-image:url('${
      buildSrc({
        id,
        hotspot,
        crop,
        height: 1750,
        width: 1750,
        baseUrl: `https://cdn.sanity.io/images/${projectId}/${dataset}/`,
        queryParams: {
          q: 90
        }
      }).src
    }'); background-position:${x * 100}% ${y * 100}%;"`;
  } catch (error) {
    return ``;
  }
}

function getAdjustedHotspot(hotspot = {}, crop = {}) {
  try {
    return [
      ['x', crop.left, crop.right],
      ['y', crop.top, crop.bottom]
    ].reduce(
      (acc, [coord, cropA, cropB]) =>
        Object.assign(acc, {
          [coord]: calculate(hotspot[coord], cropA, cropB)
        }),
      {}
    );

    function calculate(coord = 0.5, cropA, cropB) {
      if (!(coord === 0.5 && cropA === 0 && cropB === 0)) {
        return (coord - cropA) / (1 - cropA - cropB);
      }

      return coord;
    }
  } catch (error) {
    return hotspot;
  }
}